import { createContext, useContext, useState, useRef, ReactNode, FC } from "react";

interface ErrorHandlerContextValue {
  showError: boolean;
  setError: (value: boolean) => void;
  setErrorHandler: (errorMessage: string) => void;
}

interface ErrorHandlerProviderProps {
  children: ReactNode;
}

const ErrorHandlerContext = createContext<ErrorHandlerContextValue | undefined>(undefined);

export const useErrorHandler = (): ErrorHandlerContextValue => {
  const context = useContext(ErrorHandlerContext);
  if (!context) {
    throw new Error('useErrorHandler must be used within ErrorHandlerProvider');
  }
  return context;
};

export const ErrorHandlerProvider: FC<ErrorHandlerProviderProps> = ({ children }) => {
  const [showError, setError] = useState<boolean>(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const setErrorHandler = (errorMessage: string): void => {
    console.log(errorMessage);
    setError(true);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setError(false);
      timeoutRef.current = null;
    }, 10000);
  };

  const contextValue: ErrorHandlerContextValue = {
    showError,
    setError,
    setErrorHandler,
  };

  return (
    <ErrorHandlerContext.Provider value={contextValue}>
      {children}
    </ErrorHandlerContext.Provider>
  );
};